import { createFileRoute } from '@tanstack/react-router';

import { CampaignsPage } from '@/features/campaign';

export const Route = createFileRoute('/workspace/$workspaceId/campaigns/')({
  component: CampaignsPage,
});
